/**
 * @category Utils
 */
export const getMigrateParams = async (
  url: string,
  mac: string,
): Promise<{
  pl_aud_lang_p1?: string;
  pl_subt_lang_p1?: string;
  ui_language?: string;
  stream_quality?: string;
}> => {
  try {
    const response = await fetch(`${url}/settings/${mac}`);
    const responseJson = await response.json();
    return responseJson;
  } catch (e) {
    return {};
  }
};
